import { SVGProps, Ref, forwardRef } from 'react';

export const ChartLineFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 1.333C3.166 1.333 1.333 3.167 1.333 16S3.166 30.667 16 30.667 30.666 28.833 30.666 16 28.833 1.333 16 1.333m9.697 11.334L24 10.97l-6.667 6.666-4.667-4.666-6.363 6.363L8 21.03l4.666-4.666 4.667 4.666z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChartLineFilledSize32Glyph.displayName = 'ChartLineFilledSize32Glyph';
